import { DiagramWithChildrenDto } from '../../../../app/api';
import { useIsOwner } from '.';

export function useEditLock(diagram?: Pick<DiagramWithChildrenDto, 'isLocked' | 'ownerId'>) {
  const isOwner = useIsOwner(diagram);
  return diagram?.isLocked && !isOwner;
}
